import * as React from 'react';
import { Building2 } from 'lucide-react';
import { Badge, Button } from 'shared-portal-components-v2';

import type { ExternalInvitationContactRowModel } from '@/types/ExternalInvitationStep.types';

export interface ExternalInvitationContactRowProps {
  model: ExternalInvitationContactRowModel;
  onAdd: (contactId: string) => void;
}

export function ExternalInvitationContactRow(props: ExternalInvitationContactRowProps): React.JSX.Element {
  const { model, onAdd } = props;

  return (
    <div className="flex items-center gap-2 p-3 rounded-lg border border-border hover:bg-accent/50 transition-colors overflow-hidden">
      <div className="flex items-center space-x-3 min-w-0 flex-1">
        <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center shrink-0">
          <span className="text-sm font-medium">{model.initials}</span>
        </div>

        <div className="min-w-0">
          <div className="font-medium truncate">{model.name}</div>
          {model.title !== undefined && model.title.length > 0 && (
            <div className="text-xs text-muted-foreground truncate">{model.title}</div>
          )}
          <div className="text-sm text-muted-foreground truncate">{model.email}</div>
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0 ml-auto">
        {(model.organization !== undefined) ? (
          <Badge variant="outline" className="text-xs font-normal hidden sm:inline-flex items-center gap-1.5 max-w-24">
            <Building2 className="h-3 w-3 shrink-0" />
            <span className="truncate">{model.organization}</span>
          </Badge>
        ) : null}

        <Button
          type="button"
          variant="outline"
          disabled={model.isDisabled}
          onClick={() => {
            onAdd(model.contactId);
          }}
          className="h-8 px-3 whitespace-nowrap shrink-0 text-xs"
        >
          Add
        </Button>
      </div>
    </div>
  );
}

ExternalInvitationContactRow.displayName = 'ExternalInvitationContactRow';

export default ExternalInvitationContactRow;
